import { render } from "./Profile.vue?vue&type=template&id=03dd6f4e&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "@/assets/Profile.css?vue&type=style&index=0&id=03dd6f4e&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03dd6f4e"]])

export default __exports__